import React from 'react';

function HeartEyesSvg() {
  return (
    <svg
      width="72"
      height="51"
      viewBox="0 0 70 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M71.0306 35.522C71.0306 55.1532 55.1838 71.0001 35.5526 71.0001C15.9214 71.0001 0.0745239 55.1532 0.0745239 35.522C0.0745239 15.8908 15.9214 0.0439453 35.5526 0.0439453C55.1838 0.0439453 71.0306 15.8908 71.0306 35.522Z"
        fill="#FFDD67"
      />
      <path
        d="M70.7941 13.2888C70.2028 10.0957 68.4289 7.49402 65.4724 6.6662C62.2794 5.83838 59.4411 7.02098 56.7212 9.85923C55.1838 5.60186 52.8186 2.40883 49.0342 0.753191C45.2499 -0.902452 41.4656 0.28015 39.1004 3.23665C36.6169 6.31142 35.6708 11.1601 38.2726 17.4279C40.756 23.3409 51.7542 35.1669 52.109 35.5217C52.5821 35.2852 64.8811 27.5983 67.8376 23.8139C70.7941 20.1479 71.3854 16.4818 70.7941 13.2888ZM32.0048 3.23665C29.6396 0.28015 25.8552 -0.902452 22.0709 0.753191C18.2866 2.40883 15.9214 5.60186 14.384 9.85923C11.5458 7.13924 8.70752 5.83838 5.51449 6.78446C2.67625 7.61228 0.784086 10.214 0.192785 13.407C-0.398516 16.4818 0.311045 20.2661 3.14929 23.9322C6.22406 27.5983 18.5231 35.2852 18.9962 35.5217C19.3509 35.1669 30.3491 23.3409 32.8326 17.4279C35.4343 11.1601 34.4882 6.42968 32.0048 3.23665Z"
        fill="#F46767"
      />
      <path
        d="M55.6568 42.7357C55.6568 41.7896 55.0655 40.607 53.5281 40.2522C49.389 39.4244 43.3578 38.7148 35.5526 38.7148C27.7474 38.7148 21.7162 39.5427 17.577 40.2522C15.9214 40.607 15.4484 41.7896 15.4484 42.7357C15.4484 51.3687 22.0709 60.0017 35.5526 60.0017C49.0343 59.8834 55.6568 51.2504 55.6568 42.7357Z"
        fill="#664E27"
      />
      <path
        d="M50.5716 42.9717C47.9699 42.4986 42.53 41.7891 35.5526 41.7891C28.5753 41.7891 23.1353 42.4986 20.5336 42.9717C18.9962 43.2082 18.8779 43.7995 18.9962 44.7456C19.1144 45.2186 19.1144 45.9282 19.351 46.6377C19.4692 47.3473 19.7057 47.7021 20.8883 47.5838C23.1353 47.3473 48.0882 47.3473 50.3351 47.5838C51.5177 47.7021 51.636 47.3473 51.8725 46.6377C51.9908 45.9282 52.109 45.3369 52.2273 44.7456C52.2273 43.7995 52.109 43.2082 50.5716 42.9717Z"
        fill="white"
      />
    </svg>
  );
}

export default HeartEyesSvg;
